import { render, staticRenderFns } from "./select-education.vue?vue&type=template&id=20f9c082&scoped=true"
import script from "./select-education.vue?vue&type=script&lang=js"
export * from "./select-education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9c082",
  null
  
)

export default component.exports